import React, { useState, useEffect } from "react";
import { Fade, Slide, Zoom } from "react-reveal";
import { useRouter } from "next/router";
import Cookies from "js-cookie";
import { clearCookies, toastError } from "../utilities/utils";
import { API_ENDPOINT } from "../utilities/constant";
import axios from "axios";
import { usePopup } from "../context/context";
import Link from "next/link";
import FeatureRequestPopup from "../components/common/FeatureRequestPopup";
import ManualUpgradePopUp from "../components/dashboard/UpgradePopup/ManualUpgradePopUp";


const DashboardHeader = () => {
  const router = useRouter();
  const token = Cookies.get("token");
  const keywords = Cookies.get("ASSIGNED_KEYWORDS");
  const { toggleSubTerPopup } = usePopup();

  const [profileURL, setProfileURL] = useState("/images/profileIcon.svg");
  const [userEmail, setUserEmail] = useState("");
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUserDetails = async () => {
    setIsLoading(true);
    try {
      const url = API_ENDPOINT + "/userdetails/";
      const response = await axios.get(url, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      setUserData(response.data.data);
      console.log("User data from API:", response.data.data);
      
      if (response.data.data?.user?.email) {
        console.log("Email from API:", response.data.data.user.email);
        setUserEmail(response.data.data.user.email);
        // Save email to cookie for future use
        Cookies.set("email", response.data.data.user.email);
      }
    } catch (err) {
      console.log(err, "=====errr");
      // On error, use the email from cookie if available
      const cookieEmail = Cookies.get("email");
      console.log("Email from cookie:", cookieEmail);
      if (cookieEmail) {
        setUserEmail(cookieEmail);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Retrieve profileURL from cookies
    const profileURLFromCookie = Cookies.get("profileURL");
    if (profileURLFromCookie !== "null") {
      setProfileURL(profileURLFromCookie);
    }
    
    // Retrieve user email from cookies as fallback
    const userEmailFromCookie = Cookies.get("email");
    console.log("Email from cookie on load:", userEmailFromCookie);
    if (userEmailFromCookie) {
      setUserEmail(userEmailFromCookie);
    }
    
    // Always fetch latest user data from API
    fetchUserDetails();
  }, []);

  const [isPopup2, setIsPopup2] = useState(false);
  const [settingPopup, setSettingPopup] = useState(false);
  const [featureRequestOpen, setFeatureRequestOpen] = useState(false);

  const handleLogOut = () => {
    clearCookies()
    toggleSubTerPopup(true);
    router.push("/sign-in");
  };

  return (
    <div className="sticky top-0 left-0 right-0 z-40">
      <div className="flex flex-wrap md:flex-nowrap gap-3 justify-between items-center bg-greenBg pr-7 pl-7 lg:pl-2 py-[15px]">
        <div className="flex gap-3">
          {router.asPath.includes("projects") && (
            <>
              <Zoom>
                <button
                  onClick={() => router.push("/dashboard")}
                  className="hidden md:inline-flex items-center gap-2 text-sm text-white font-medium bg-coolGreen border border-coolGreen hover:bg-white hover:text-coolGreen transition-all duration-150 rounded-lg px-4 py-2 shadow-sm ml-3"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="transition-colors duration-150"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                  Back to Dashboard
                </button>
              </Zoom>
            </>
          )}
        </div>
        <div className="flex items-center gap-5">
          <button
            onClick={() => setIsPopup2(true)}
            className="text-white flex items-center gap-3 bg-[#015746] py-2.5 rounded-lg px-4 hover:scale-105 transition-all duration-200 shadow-sm hover:shadow-md border border-[#01735b]/30 hover:border-[#01735b]/70 relative overflow-hidden group"
          >
            <span className="absolute inset-0 bg-[#015746] opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              className="relative z-10 group-hover:rotate-12 transition-transform duration-300"
            >
              <path
                d="M3.74967 13.75C2.49967 14.8 2.08301 17.9167 2.08301 17.9167C2.08301 17.9167 5.19967 17.5 6.24967 16.25C6.84134 15.55 6.83301 14.475 6.17467 13.825C5.85076 13.5159 5.42409 13.3372 4.97653 13.3234C4.52897 13.3096 4.09207 13.4615 3.74967 13.75Z"
                fill="white"
              />
              <path
                d="M9.99967 12.5L7.49967 10C7.94313 8.84957 8.50151 7.74676 9.16634 6.70838C10.1373 5.15587 11.4894 3.87758 13.0938 2.99512C14.6983 2.11266 16.5019 1.65535 18.333 1.66671C18.333 3.93338 17.683 7.91671 13.333 10.8334C12.2804 11.499 11.1637 12.0573 9.99967 12.5Z"
                fill="white"
              />
              <path
                d="M7.49967 10H3.33301C3.33301 10 3.79134 7.47504 4.99967 6.66671C6.34967 5.76671 9.16634 6.66671 9.16634 6.66671"
                fill="white"
              />
              <path
                d="M9.99967 12.5V16.6667C9.99967 16.6667 12.5247 16.2084 13.333 15C14.233 13.65 13.333 10.8334 13.333 10.8334"
                fill="white"
              />
            </svg>
            <span className="relative z-10">Upgrade Now</span>
          </button>
          {/* Hiding Notifications */}
          {/* <button className="">
           
          <svg width="32" className=" relative z-10" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3333 32C10.5774 32 8.33325 29.7573 8.33325 27C8.33325 26.448 8.78125 26 9.33325 26C9.88525 26 10.3333 26.448 10.3333 27C10.3333 28.6548 11.6799 30 13.3333 30C14.9866 30 16.3333 28.6548 16.3333 27C16.3333 26.448 16.7813 26 17.3333 26C17.8853 26 18.3333 26.448 18.3333 27C18.3333 29.7573 16.0894 32 13.3333 32Z" fill="white"/>
<path d="M24.3332 28H2.33325C1.04663 28 4.43121e-07 26.9533 4.43121e-07 25.6667C-0.000207289 25.3297 0.0726251 24.9967 0.213483 24.6905C0.35434 24.3844 0.559876 24.1124 0.815938 23.8933C0.849375 23.864 0.885313 23.8373 0.922625 23.8132C2.87988 22.1052 4 19.6479 4 17.0532V13.3332C4 8.99072 6.94262 5.26266 11.156 4.2666C11.6946 4.14254 12.2334 4.47191 12.3601 5.01072C12.4866 5.5481 12.1533 6.08666 11.6174 6.21335C8.30931 6.9946 6 9.9226 6 13.3332V17.0532C6 20.2747 4.58788 23.3227 2.12938 25.4145C2.10938 25.4307 2.09206 25.4453 2.07056 25.4599C2.02424 25.5188 1.99935 25.5918 2 25.6667C2 25.8478 2.15213 26 2.33325 26H24.3332C24.5146 26 24.6667 25.8478 24.6667 25.6667C24.6667 25.5732 24.6321 25.5053 24.5947 25.4599C24.5747 25.4453 24.5559 25.4307 24.5374 25.4145C23.3427 24.396 22.3999 23.1667 21.7361 21.76C21.4987 21.2612 21.7119 20.6653 22.2119 20.428C22.3306 20.3716 22.4592 20.3393 22.5904 20.3328C22.7216 20.3263 22.8528 20.3458 22.9765 20.3902C23.1001 20.4345 23.2138 20.5028 23.311 20.5912C23.4082 20.6796 23.4869 20.7863 23.5427 20.9052C24.0706 22.02 24.8106 22.9987 25.7466 23.8173C25.7812 23.8413 25.8174 23.8667 25.8479 23.8933C26.1048 24.1118 26.3112 24.3836 26.4526 24.6898C26.594 24.9961 26.6671 25.3294 26.6667 25.6667C26.6667 26.9533 25.6201 28 24.3332 28Z" fill="white"/>
<path d="M23.3332 17.3333C18.5547 17.3333 14.6667 13.4453 14.6667 8.66675C14.6667 3.88794 18.5547 0 23.3332 0C28.1121 0 32 3.88794 32 8.66675C32 13.4453 28.1121 17.3333 23.3332 17.3333ZM23.3332 2C19.6572 2 16.6667 4.99075 16.6667 8.66675C16.6667 12.3428 19.6572 15.3333 23.3332 15.3333C27.0092 15.3333 30 12.3428 30 8.66675C30 4.99075 27.0092 2 23.3332 2Z" fill="#17B26A"/>
</svg>

          </button> */}
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12.4996 11V7.5M12.4996 14.5H12.5096M12.4996 20C17.194 20 20.9996 16.1944 20.9996 11.5C20.9996 6.80558 17.194 3 12.4996 3C7.8052 3 3.99962 6.80558 3.99962 11.5C3.99962 12.45 4.15547 13.3636 4.443 14.2166C4.55119 14.5376 4.60529 14.6981 4.61505 14.8214C4.62469 14.9432 4.6174 15.0286 4.58728 15.1469C4.55677 15.2668 4.48942 15.3915 4.35472 15.6408L2.71906 18.6684C2.48575 19.1002 2.36909 19.3161 2.3952 19.4828C2.41794 19.6279 2.50337 19.7557 2.6288 19.8322C2.7728 19.9201 3.01692 19.8948 3.50517 19.8444L8.62619 19.315C8.78127 19.299 8.85881 19.291 8.92949 19.2937C8.999 19.2963 9.04807 19.3029 9.11586 19.3185C9.18478 19.3344 9.27145 19.3678 9.44478 19.4345C10.3928 19.7998 11.4228 20 12.4996 20Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg> */}
          <div className="relative">
            <div className="">
              <div className="h-2.5 w-2.5 bg-coolGreen rounded-full absolute bottom-0 right-0 border border-[#002E25]" />
              <img
                className="cursor-pointer object-cover"
                style={{ borderRadius: "50%" }}
                onClick={() => setSettingPopup(!settingPopup)}
                height={36}
                width={36}
                src={profileURL || "/images/profileIcon.svg"} // Default to profileIcon.svg
                alt="User Profile"
              />
            </div>
            {/* <svg className="cursor-pointer" onClick={() => setSettingPopup(!settingPopup)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6 9L12 15L18 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg> */}
            {settingPopup && (
              <Fade bottom duration={300}>
                <div
                  onClick={() => setSettingPopup(!settingPopup)}
                  className="fixed h-screen w-screen top-0 left-0 !z-30 "
                />
                <div className="bg-white border shadow-lg cursor-pointer !z-50 absolute w-64 text-[#4B5563] top-12 right-0 rounded-lg py-5 px-3">
                  <div className="px-3 pb-3 border-b border-gray-200">
                    <div className="text-gray-500 text-sm mb-1">Signed in as</div>
                    <div className="font-medium text-gray-800">
                      {isLoading 
                        ? "Loading..." 
                        : (userEmail || (userData?.user?.email) || Cookies.get("email") || "Unknown email")}
                    </div>
                  </div>
                  
                  <div className="py-2">
                    <Link href="/dashboard/settings">
                      <div 
                        className="px-3 py-2.5 hover:bg-gray-50 rounded-md text-sm flex items-center transition-colors"
                        onClick={() => {
                          setSettingPopup(false);
                          localStorage.setItem('selectedSettingsTab', '4');
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-3 text-gray-400">
                          <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                          <line x1="2" x2="22" y1="10" y2="10"></line>
                        </svg>
                        Billings & Plans
                      </div>
                    </Link>
                    
                    <div 
                      className="px-3 py-2.5 hover:bg-gray-50 rounded-md text-sm flex items-center transition-colors cursor-pointer"
                      onClick={() => {
                        setSettingPopup(false);
                        setFeatureRequestOpen(true);
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-3 text-gray-400">
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                      </svg>
                      Feature Request
                    </div>
                    
                    <Link href="/dashboard/settings">
                      <div 
                        className="px-3 py-2.5 hover:bg-gray-50 rounded-md text-sm flex items-center transition-colors"
                        onClick={() => setSettingPopup(false)}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-3 text-gray-400">
                          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        Account settings
                      </div>
                    </Link>
                  </div>
                  
                  <div className="pt-2 border-t border-gray-200">
                    <div 
                      className="px-3 py-2.5 hover:bg-gray-50 rounded-md text-sm flex items-center transition-colors cursor-pointer"
                      onClick={() => {
                        setSettingPopup(false);
                        handleLogOut();
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-3 text-gray-400">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                        <polyline points="16 17 21 12 16 7"></polyline>
                        <line x1="21" y1="12" x2="9" y2="12"></line>
                      </svg>
                      Log out
                    </div>
                  </div>
                </div>
              </Fade>
            )}
          </div>
        </div>
      </div>
      {isPopup2 ? (
        <ManualUpgradePopUp setIsPopup={setIsPopup2} isPopup={isPopup2} />
      ) : null}

      {/* Feature Request Popup */}
      <FeatureRequestPopup 
        isOpen={featureRequestOpen} 
        onClose={() => setFeatureRequestOpen(false)} 
      />
    </div>
  );
};

export default DashboardHeader;
